export default __webpack_public_path__ + "static/media/cl.418907f8.png";